import { useEffect, useMemo, useRef } from "react";
import { v4 as uuid } from "uuid";
import Icon from "../Icon";
import { styles } from "./styles";
import { CheckboxProps } from "./types";
import { CHECKBOX_FILL_VAR, CHECKBOX_ICON_SIZE } from "./constants";

/**
 * `Checkbox` components allow users to make a binary decisions.
 */
const Checkbox = ({
  children,
  checked,
  disabled = false,
  indeterminate = false,
  id = `kit-${uuid()}`,
  ellipses = false,
  icon: iconProp,
  value,
  error = false,
  onChange
}: CheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!inputRef.current) return;

    inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  const icon = useMemo(
    () =>
      typeof iconProp == "string" ? (
        <Icon name={iconProp} size={CHECKBOX_ICON_SIZE} />
      ) : (
        iconProp
      ),
    [iconProp]
  );

  return (
    <label
      className="kit-Checkbox"
      css={[styles.wrapper, error && styles.error]}
    >
      <input
        type="checkbox"
        ref={inputRef}
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        value={String(value)}
      />
      <div>
        {indeterminate ? (
          <Icon
            name="Minus"
            size={CHECKBOX_ICON_SIZE}
            fill={`var(${CHECKBOX_FILL_VAR})`}
          />
        ) : (
          checked && (
            <Icon
              name="Check"
              size={CHECKBOX_ICON_SIZE}
              fill={`var(${CHECKBOX_FILL_VAR})`}
            />
          )
        )}
      </div>

      {(!!children || !!icon) && (
        <span css={[styles.label, ellipses && styles.ellipses]}>
          {icon}
          {children}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
export * from "./types";
